export const staticURLRoot = '/';
export const staticURLBena2 = '/';
export const staticURLLogin = '/account/login';
export const staticURLAccount = '/account';